<template>
    <div>
        <base-button
            :class="[{'disabled': invalid}]"
            :disabled="invalid"
            :type="buttonType"
            native-type="submit"
            @click="$emit('submit')">
            <slot>
                {{ nextLabel ? nextLabel : $t('eventRegistration.next') }}
            </slot>
        </base-button>
    </div>
</template>
<script>
export default {
    name: 'NextButton',
    props: {
        invalid: {type: Boolean, default: false},
        nextLabel: {type: String},
        buttonType: {type: String, default: 'default'}
    }
}
</script>
